@use '../../styles/screen-reader-only';

hp6-screen-reader-only {
  @include screen-reader-only.screen-reader-only;
}
